import React from "react";
import { useTranslation } from "react-i18next";
import "../AllProducts/AllProducts.css";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import BoardsHero from "../../components/pages/AllProducts/Boards/BoardsHero/BoardsHero";
import BoardsTypes from "../../components/pages/AllProducts/Boards/BoardsTypes/BoardsTypes";
import AllProductsExplore from "../../components/pages/AllProducts/AllProductsExplore/AllProductsExplore";
import { useProductsExploreSection } from "../../hooks/usePublicQueries";

const Boards = () => {
  const { i18n } = useTranslation();
  const { data: exploreContent } = useProductsExploreSection(i18n.language);

  return (
    <div className="products-page">
      <div className="products-page-content-guide">
        <Navbar theme="dark" />
        <BoardsHero />
        <BoardsTypes />
        <AllProductsExplore content={exploreContent} />
      </div>
      <Footer />
    </div>
  );
};

export default Boards;
